import { Shield, Star, Users, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
const HOTMART_CHECKOUT_URL = "https://pay.hotmart.com/X103718093T?checkoutMode=10";
const HeroSection = () => {
  const handleBuyClick = () => {
    window.open(HOTMART_CHECKOUT_URL, "_blank");
  };
  return <section className="relative overflow-hidden gradient-hero py-12 sm:py-16 lg:py-24">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }} />
      </div>
      
      <div className="container-centered relative z-10">
        {/* Logo/Brand */}
        <div className="mb-8 text-center">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 backdrop-blur-sm">
            <Shield className="h-5 w-5 text-white" />
            <span className="font-display font-semibold text-white text-xl">
              Universo Digital Academy
            </span>
          </div>
        </div>

        {/* Main Headline */}
        <div className="mx-auto max-w-4xl text-center">
          <h1 className="font-display text-3xl font-extrabold leading-tight text-white sm:text-4xl md:text-5xl lg:text-6xl">
            De Inmigrante a{" "}
            <span className="relative inline-block">
              <span className="relative z-10 text-accent">Dueño de Tu Crédito</span>
              
            </span>{" "}
            en 90 Días
          </h1>
          
          <p className="mx-auto mt-6 max-w-2xl text-lg font-extrabold text-center sm:text-3xl text-primary">
            Guía paso a paso para reparar, construir y proteger tu crédito en EE. UU.
          </p>

          {/* Social Proof */}
          <div className="mt-8 flex flex-wrap items-center justify-center gap-4 sm:gap-8">
            <div className="flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 backdrop-blur-sm">
              <Users className="h-5 w-5 text-accent" />
              <span className="text-sm font-semibold text-white">1547+ Latinos ya están usando este sistema</span>
            </div>
            
            <div className="flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 backdrop-blur-sm">
              <div className="flex -space-x-1">
                {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-accent text-accent" />)}
              </div>
              <span className="text-sm font-semibold text-white">
                4.9/5 Calificación
              </span>
            </div>
          </div>

          {/* Subheadline */}
          <div className="mt-10 inline-block rounded-2xl bg-white/10 px-6 py-4 backdrop-blur-sm">
            <p className="text-lg font-semibold text-white sm:text-xl">
              🎯 ¡El Siguiente Eres{" "}
              <span className="text-accent underline decoration-accent decoration-2 underline-offset-4">
                TÚ
              </span>
              !
            </p>
          </div>

          {/* CTA Button */}
          <div className="mt-8 btn-container">
            <Button onClick={handleBuyClick} size="lg" className="btn-cta relative h-14 bg-gradient-to-r from-teal-500 via-cyan-400 to-amber-500 px-6 pl-12 text-base font-bold text-slate-900 shadow-[0_0_30px_rgba(20,184,166,0.4)] transition-all hover:scale-105 animate-pulse-glow sm:h-16 sm:px-10 sm:pl-14 sm:text-lg">
              <Zap className="absolute left-5 h-5 w-5" />
              <span className="block w-full text-center whitespace-normal leading-tight">
                QUIERO TRANSFORMAR MI CRÉDITO AHORA
              </span>
            </Button>
            <p className="mt-3 font-bold text-4xl text-center text-secondary-foreground">
              Solo $16.99 • Acceso inmediato • Garantía 60 días
            </p>
          </div>
        </div>
      </div>

      {/* Bottom wave - connects to next section */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
          <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="hsl(222 47% 11%)" />
        </svg>
      </div>
    </section>;
};
export default HeroSection;